<script>
import baseMixin from '@/mixins/baseMixin'
import { mapGetters } from 'vuex'
import dayjs from '@/services/date'

export default {
  name: 'InterestChargesDialog',
  mixins: [baseMixin],
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    charges: {
      type: Array,
      required: true,
    },
  },
  data: (vm) => {
    return {
      headers: [
        {
          text: vm.$t(
            'finance.overdueInvoices.columnHeadings.overdueInvoiceNo'
          ),
          value: 'referenceInvoiceNo',
        },
        {
          text: vm.$t(
            'finance.overdueInvoices.columnHeadings.interestInvoiceNo'
          ),
          value: 'invoiceNo',
        },
        {
          text: vm.$t(
            'finance.overdueInvoices.columnHeadings.interestInvoiceRun'
          ),
          value: 'invoiceRun',
        },
        {
          text: vm.$t(
            'finance.overdueInvoices.columnHeadings.interestInvoiceDate'
          ),
          value: 'invoiceDate',
        },
        {
          text: vm.$t('finance.overdueInvoices.columnHeadings.interestCharged'),
          value: 'totalExTax',
          align: 'end',
          cellClass: 'font-weight-bold',
        },
        {
          text: vm.$t('finance.overdueInvoices.columnHeadings.paid'),
          value: 'hasBeenPaid',
          align: 'center',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      invoiceCenterLocale: 'finance/currentInvoiceCenterLocale',
    }),
  },
  methods: {
    closeDialog() {
      this.$emit('close-dialog')
    },
    localisedInvoiceDate(val) {
      return this.$d(dayjs(val), 'dateFormatted', this.invoiceCenterLocale)
    },
    generateInvoiceRunUrl(invoiceRun) {
      return `${this.reliefRosterUrl}/Finance/ViewInvoiceRun/${invoiceRun}`
    },
  },
}
</script>

<template>
  <v-dialog
    :value="showDialog"
    max-width="950px"
    @input="(v) => v || closeDialog()"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5 mb-1">{{
          $t('finance.overdueInvoices.interestChargesDialogTitle')
        }}</span>
      </v-card-title>
      <v-card-subtitle>
        <span data-testid="title">{{ title }}</span>
      </v-card-subtitle>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="charges"
          item-key="id"
          :sort-by="['totalExTax']"
          :sort-desc="[true]"
          class="charges-table elevation-1"
        >
          <template v-slot:item.invoiceRun="{ item }">
            <BaseLink
              v-if="isEmbedded"
              :href="generateInvoiceRunUrl(item.invoiceRun)"
              @click.stop
              >{{ item.invoiceRun }}</BaseLink
            ><span v-else>{{ item.invoiceRun }}</span>
          </template>
          <template v-slot:item.invoiceDate="{ item }">
            {{ localisedInvoiceDate(item.invoiceDate) }}
          </template>
          <template v-slot:item.totalExTax="{ item }">
            <i18n-n
              :value="item.totalExTax"
              format="currency"
              :locale="invoiceCenterLocale"
            ></i18n-n>
          </template>
          <template v-slot:item.hasBeenPaid="{ item }">
            <v-icon
              v-if="item.hasBeenPaid"
              class="paid-icon paid-icon--has-been-paid"
              color="success"
              >mdi-check-circle</v-icon
            >
            <v-icon v-else color="error" class="paid-icon paid-icon--unpaid"
              >mdi-close-circle-outline</v-icon
            >
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeDialog">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
